import { render, staticRenderFns } from "./personalityItemHot.vue?vue&type=template&id=599d9831&scoped=true&"
import script from "./personalityItemHot.vue?vue&type=script&lang=js&"
export * from "./personalityItemHot.vue?vue&type=script&lang=js&"
import style0 from "./personalityItemHot.vue?vue&type=style&index=0&id=599d9831&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d9831",
  null
  
)

export default component.exports